import { AppBar } from "@features/dashboard/layouts/AppBar";
import { LessonsHomeScreen } from "@memorang/ui/components/LessonsHomeScreen/LessonsHomeScreen";
import { useRouter } from "expo-router";
import {
	allModules,
	completedModules,
	continueLearningModules,
	suggestedModules,
} from "../constants";

export const ModulesContainer = () => {
	const router = useRouter();

	const handleOpenModule = ({ id }: { id: string }) => {
		router.push(`/modules/${id}`);
	};

	const handleViewAllPress = () => {
		//TODO: open full modules list once explore screen lands
	};

	return (
		<>
			<AppBar title="Modules" />
			<LessonsHomeScreen
				continueLearningLessons={continueLearningModules}
				suggestedLessons={suggestedModules}
				completedLessons={completedModules}
				allLessons={allModules}
				allLessonsTitle="All modules"
				onResumePress={handleOpenModule}
				onSuggestedLessonPress={handleOpenModule}
				onCompletedLessonPress={handleOpenModule}
				onLessonPress={handleOpenModule}
				onViewAllPress={handleViewAllPress}
			/>
		</>
	);
};
